module.exports = __webpack_public_path__ + "img/favicon-196-modified.8ccc855b.png";